import { FormList } from './../../core/models/form-list.model';
import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap";
import { FormService } from "../../core/services/form.service";
import { CommonService } from "../../core/services/common.service";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { validateEmail } from "../../common/validators/email-validator.directive";
import { validateAllowedCharacters } from "../../common/validators/allowed-characters-validator.directive";
import { validateNumericCharacters } from "../../common/validators/numeric-validator.directive";
import { validateLength } from "../../common/validators/length-validator.directive";

@Component({
    selector: 'app-form-invite-modal',
    templateUrl: './form-invite-modal.component.html',
    styleUrls: ['./form-invite-modal.component.css']
})
export class FormInviteModalComponent {

    forms: FormList[];
    message: string;
    email: string;
    data: {};
    inviteForm: FormGroup;
    isSubmitting:boolean = false;

    @ViewChild('sendInvite')
    public sendInvite: ModalDirective;

    constructor(
        private formService: FormService,
        private commonService: CommonService,
        private fb: FormBuilder,
    ) {
        this.initForm();
    }

    // Making the field values blank.
    initForm() {
        this.inviteForm = this.fb.group({
            'form_id': ['', [Validators.required]],
            'message': [''],
            'candidates': this.fb.array([this.initItemRows()])
        });
    }

    initItemRows() {
        return this.fb.group({
            email: ['', [Validators.required, validateEmail()]],
            name: ['', [Validators.required, validateAllowedCharacters('')]],
            phone_number: ['', [Validators.pattern( /^(\s*\d{10}\s*,\s*)*\s*\d{10}\s*$/ )]]
        });
    }

    get candidatesArray(): FormArray {
        return this.inviteForm.get('candidates') as FormArray;
    };

    addNewRow() {
        // control refers to your form array
        const control = <FormArray>this.inviteForm.controls['candidates'];
        // add new formgroup
        control.push(this.initItemRows());
    }

    deleteRow(index: number) {
        // control refers to your form array
        const control = <FormArray>this.inviteForm.controls['candidates'];
        // remove the chosen row
        control.removeAt(index);
    }

    show() {
        this.forms = [];

        this.initForm();

        this.formService.getFormsList().subscribe(
            response => {
                this.forms = response;
            }
        );

        this.sendInvite.show();
    }

    hide() {
        this.initForm();
        this.sendInvite.hide();
    }

    sendMail() {
        this.isSubmitting = true;
        this.formService.sendMail(this.inviteForm.value).subscribe(
            response => {

                this.commonService.notifications.success('Success', response['message']);
                this.isSubmitting = false;
                this.hide();

            },
            error => {
                this.commonService.notifications.error('Error', 'Unable to send mail');
                this.isSubmitting = false;
                this.hide();
            }
        );

    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/form/form-invite-modal/form-invite-modal.component.ts